"use client";

import { useEffect, useId, useState } from "react";
import { PerplexityChart } from "@/components/charts/PerplexityChart";
import { research } from "@/content/research";
import { decimal, optimalDepth, perplexitySweep } from "@/content/research-data";
import { worldBus } from "@/lib/world-bus";
import styles from "./research.module.css";

// Gráfico 1 sincronizado con el árbol (guía 7.4 y 11): el control de 1 a 16 vueltas
// mueve la escena y el gráfico juntos. En una vuelta el árbol duda; en siete está
// sereno y verifica; de ocho a dieciséis queda idéntico a siete (la meseta es un dato
// real y se muestra tal cual).
export function LoopsExplorer() {
  const [loops, setLoops] = useState(optimalDepth);
  const id = useId();
  const point = perplexitySweep.find((p) => p.depth === loops) ?? perplexitySweep[0];

  useEffect(() => {
    worldBus.treeLoops = loops;
  }, [loops]);

  useEffect(
    () => () => {
      worldBus.treeLoops = optimalDepth;
    },
    [],
  );

  return (
    <div className={styles.explorer}>
      <PerplexityChart selected={loops} title={research.results.chart1.title} />
      <div className={styles.control}>
        <label htmlFor={id} className={styles.controlLabel}>
          {research.results.chart1.control}
        </label>
        <div className={styles.controlRow}>
          <input
            id={id}
            type="range"
            min={1}
            max={16}
            step={1}
            value={loops}
            onChange={(e) => setLoops(Number(e.target.value))}
            className={styles.range}
            aria-valuetext={`${loops} ${loops === 1 ? "vuelta" : "vueltas"}, perplejidad ${decimal(point.forced, 2)}`}
          />
          {/* data-raw: doble clic muestra el dato crudo de esa vuelta (easter egg 3.11). */}
          <output htmlFor={id} className={styles.readout} aria-live="polite" data-raw={`forced:${loops}`}>
            <span className={styles.readoutNum}>{loops}</span> {loops === 1 ? "vuelta" : "vueltas"} ·{" "}
            <span className={styles.readoutNum}>{decimal(point.forced, 2)}</span>
          </output>
          <button type="button" className={styles.replay} onClick={() => worldBus.treeReplay++}>
            {research.results.chart1.replay}
          </button>
        </div>
      </div>
    </div>
  );
}
